// Todas as classes disponíveis
export const CLASSES = [
  'GUERREIRA',
  'ASSASSINA',
  'ARQUEIRA',
  'LUTADOR',
  'PIKE',
  'MECANICO',
  'XAMA',
  'SACERDOTISA',
  'CAVALEIRO',
  'MAGO',
  'ATALANTA',
];

// Traduções dos tipos de classes para português
export const CLASS_TYPES = {
  'GUERREIRA': 'Guerreira',
  'ASSASSINA': 'Assassina',
  'ARQUEIRA': 'Arqueira',
  'LUTADOR': 'Lutador',
  'PIKE': 'Pike',
  'MECANICO': 'Mecânico',
  'XAMA': 'Xamã',
  'SACERDOTISA': 'Sacerdotisa',
  'CAVALEIRO': 'Cavaleiro',
  'MAGO': 'Mago',
  'ATALANTA': 'Atalanta'
};

// Função para obter a tradução do tipo de classe
export const getClassTypeTranslation = (type) => {
  return CLASS_TYPES[type] || type;
};

// Ícones dos tipos de classe
export const getClassTypeIcon = (type) => {
  const typeIcons = {
    'GUERREIRA': '⚔️',
    'ASSASSINA': '🗡️',
    'ARQUEIRA': '🏹',
    'LUTADOR': '👊',
    'PIKE': '🔱',
    'MECANICO': '🔧',
    'XAMA': '🌿',
    'SACERDOTISA': '✨',
    'CAVALEIRO': '🛡️',
    'MAGO': '🔮',
    'ATALANTA': '🏃‍♀️'
  };
  return typeIcons[type] || '📦';
};

export const getClassAbbreviatedName = (type) => {
  const typeIcons = {
    'GUERREIRA': 'GR',
    'ASSASSINA': 'ASS',
    'ARQUEIRA': 'AS',
    'LUTADOR': 'FS',
    'PIKE': 'PS',
    'MECANICO': 'MS',
    'XAMA': 'XM',
    'SACERDOTISA': 'PRS',
    'CAVALEIRO': 'KS',
    'MAGO': 'MG',
    'ATALANTA': 'ATA️'
  };
  return typeIcons[type] || '📦';
};

export const characterClasses = [
  {value: 'GUERREIRA', label: 'Guerreira', emoji: '⚔️'},
  {value: 'ASSASSINA', label: 'Assassina', emoji: '🗡'},
  {value: 'ARQUEIRA', label: 'Arqueira', emoji: '🏹'},
  {value: 'LUTADOR', label: 'Lutador', emoji: '👊'},
  {value: 'PIKE', label: 'Pike', emoji: '🔱'},
  {value: 'MECANICO', label: 'Mecânico', emoji: '🔧'},
  {value: 'XAMA', label: 'Xamã', emoji: '🌿'},
  {value: 'SACERDOTISA', label: 'Sacerdotisa', emoji: '✨'},
  {value: 'CAVALEIRO', label: 'Cavaleiro', emoji: '🛡️'},
  {value: 'MAGO', label: 'Mago', emoji: '🔮'},
  {value: 'ATALANTA', label: 'Atalanta', emoji: '🏃‍♀️'}
];

export const getClassTypeCollor = (type) => {
  const typeCollors = {
    'GUERREIRA': 'bg-red-500/20 text-red-400 border border-red-500/30',
    'ASSASSINA': 'bg-gray-500/20 text-gray-400 border border-gray-500/30',
    'ARQUEIRA': 'bg-green-500/20 text-green-400 border border-green-500/30',
    'LUTADOR': 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30',
    'PIKE': 'bg-orange-500/20 text-orange-400 border border-orange-500/30',
    'MECANICO': 'bg-slate-500/20 text-slate-400 border border-slate-500/30',
    'XAMA': 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30',
    'SACERDOTISA': 'bg-pink-500/20 text-pink-400 border border-pink-500/30',
    'CAVALEIRO': 'bg-blue-500/20 text-blue-400 border border-blue-500/30',
    'MAGO': 'bg-indigo-500/20 text-indigo-400 border border-indigo-500/30',
    'ATALANTA': 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
  };

  return typeCollors[type] || 'bg-blue-500/20 text-blue-400 border border-blue-500/30';
}

export const getClassCollor = (type) => {
  const typeCollors = {
    'GUERREIRA': 'text-red-400',
    'ASSASSINA': 'text-gray-400',
    'ARQUEIRA': 'text-green-400',
    'LUTADOR': 'text-yellow-400',
    'PIKE': 'text-orange-400',
    'MECANICO': 'text-slate-400',
    'XAMA': 'text-emerald-400',
    'SACERDOTISA': 'text-pink-400',
    'CAVALEIRO': 'text-blue-400',
    'MAGO': 'text-indigo-400',
    'ATALANTA': 'text-purple-400',
  };

  return typeCollors[type] || 'text-red-400';
}

export const getCharacterStatsText = (status) => {
  const variants = {
    PENDING: 'Pendente',
    APPROVED: 'Aprovado',
    REJECTED: 'Rejeitado',
    SUSPENDED: 'Suspenso',
    ACTIVE: 'Ativo',
    INACTIVE: 'Inativo',
  };

  return variants[status] || 'Não status não configurado'
}


export const BUFF_CLASSES = ['XAMA', 'MECANICO', 'CAVALEIRO', 'ARQUEIRA', 'GUERREIRA', 'ASSASSINA', 'ATALANTA', 'SACERDOTISA'];
export const BUFFS_MINIMO = ['XAMA', 'MECANICO', 'CAVALEIRO', 'ARQUEIRA', 'GUERREIRA', 'ASSASSINA'];